import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import TopBar from "../../../components/template/TopBar/TopBar";
import ASSET_PATHS from "../../../assets/config/assetPaths";
import { useSwipeable } from "react-swipeable";
import AssetCard from "../../../components/template/Card/AssetCard";
import { useNavigate, useParams } from "react-router-dom";
import { AppDispatch, RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import { fetchWorkOrderDetails, updateAssetStatus } from "../../../redux/slices/workOrderDetailSlice";
import { WorkOrderStatus } from "../../../types/workOrder";
import PullToRefresh from "react-simple-pull-to-refresh";
import BlockConfirmationModal from "../../../components/template/Modal/BlockConfirmationModal";
import UnSkipModal from "../../../components/template/Modal/UnSkipModal";
// import SubmitWorkOrderModal from "../../../components/template/Modal/SubmitWorkOrder";
// import { submitInspectionData } from "../../../redux/slices/workOrderSlice";
// import { ImSpinner2 } from "react-icons/im";
import { isOfflineMode } from "../../../shared/offlineManager";


const Assets: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const [isSkipModalOpen, setIsSkipModalOpen] = useState(false);
  const [isUnSkipModalOpen, setIsUnSkipModalOpen] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState<any>(null);

  const { workOrderDetail } = useSelector((state: RootState) => state.workOrderDetail);
  const token = useSelector((state: RootState) => state.auth?.token);
  const { workOrders } = useSelector((state: RootState) => state.workOrders);

  const { id } = useParams();
  const workOrder_ID = id ? parseInt(id) : 0;
  const matchingOrder = workOrders.find(
    (order) => order.workOrder_ID === workOrder_ID
  );
  const { items } = useSelector(
    (state: RootState) => state.pendingUploadsQueue
  );
  const matchWorkOrderPending = items.some((item: any) => item.workOrderId === workOrder_ID);
  const [showToast, setShowToast] = useState(true);
  // const [isSubmitWorkOrderModalOpen, setIsSubmitWorkOrderModalOpen] = useState(false);
  // const [isLoading, setIsLoading] = useState<boolean>(false);
  const handlers = useSwipeable({
    onSwiped: () => setShowToast(false),
    preventScrollOnSwipe: true,
    trackTouch: true,
    trackMouse: false,
  });

  // const handleCloseSubmitWorkOrderModal = () => {
  //   setIsSubmitWorkOrderModalOpen(false);
  // };

  // const handleSubmitWorkOrder = async () => {
  //   try {
  //       setIsLoading(true)
  //       const submitResult = await dispatch(submitInspectionData({ token, inspectionData: {}, workOrder_ID: workOrder_ID }));

  //       if (submitResult.meta.requestStatus === "fulfilled") {
  //           handleCloseSubmitWorkOrderModal();
  //       } else {
  //           setIsLoading(false);
  //           console.log("Failed to to submit work order", submitResult);
  //       }
  //   } catch (err: any) {
  //       console.log('failed:', err);
  //   } finally {
  //       setIsLoading(false);
  //   }
  // }
  const navigateToAddAsset = () => {
    navigate(`/add-asset/${workOrder_ID}`);
  };

  const handleOpenSkipModal = (asset: any) => {
    setSelectedAsset(asset);
    setIsSkipModalOpen(true);
  };

  const handleCloseSkipModal = () => {
    setIsSkipModalOpen(false);
    setSelectedAsset(null);
  };

  const handleOpenUnSkipModal = (asset: any) => {
    setSelectedAsset(asset);
    setIsUnSkipModalOpen(true);
  };

  const handleCloseUnSkipModal = () => {
    setIsUnSkipModalOpen(false);
    setSelectedAsset(null);
  };

  const getSingleWorkOrderDetail = async () => {
    if (!isOfflineMode() && !matchWorkOrderPending) {
      try {
        const resultAction = await dispatch(fetchWorkOrderDetails({ token, workorder_id: workOrder_ID }));
  
        if (fetchWorkOrderDetails.fulfilled.match(resultAction)) {
        } else {
          console.log("Failed to fetch work order details");
        }
      } catch (error) {
        console.log("Internal Server Error", error);
      }
    }
    if (matchWorkOrderPending) {
      console.log('Pending work order')
    }
  };

  useEffect(() => {
    if (workOrder_ID !== 0) {
      getSingleWorkOrderDetail();
    }
  }, [workOrder_ID]);

  const handleSkipUnSkipBlockItem = async () => {
    if (!selectedAsset) return;
    const updated = await dispatch(
      updateAssetStatus({
        token,
        asset_id: selectedAsset?.id,
        status: selectedAsset.status_ID == 4 ? selectedAsset?.modules?.length == selectedAsset?.totalVerifiedModules ? 3 : 1 : 4,
        workOrder_ID,
        data: {
          metaData: {
            workOrderId: workOrder_ID,
            description: `Item '${selectedAsset.description}' failed to '${selectedAsset.status_ID == 4 ? 'unskip' : 'skip'}'.`, 
          },
       },
        shouldNotify: true,
        shouldUpdateCompleteAssetCount: !(selectedAsset?.modules?.length == selectedAsset?.totalVerifiedModules)
      })
    );
    if (updated.meta.requestStatus === "fulfilled") {
      handleCloseSkipModal();
      handleCloseUnSkipModal();
    }
  };

  return (
    <>
      <PullToRefresh
        onRefresh={getSingleWorkOrderDetail}
        refreshingContent={
          <div className="flex justify-center items-center mt-4">
            <div className="w-8 h-8 border-4 border-t-transparent border-blue-500 rounded-full animate-spin"></div>
          </div>}
      >
        <div className="min-h-screen flex flex-col bg-gray-100">
          <TopBar title="Items" showBackIcon={true} navigateTo="/" />
          <div className="p-4">
            <div className="bg-primary text-white py-4 px-2 rounded-t-2xl shadow-md">
              <div className="relative flex justify-between items-start">
                <div className="flex flex-col gap-2 w-[70%]">
                  <div className="flex gap-1">
                    <img src={ASSET_PATHS.docWhiteIcon} alt="Retry" />
                    <p className="text-sm font-bold flex items-center">#{workOrder_ID}</p>
                  </div>
                  <div className="flex gap-1">
                    <img src={ASSET_PATHS.officeBuildingWhite} alt="Retry" />
                    <p className="text-sm flex items-center">{matchingOrder?.accountName}</p>
                  </div>
                  <div className="flex gap-1">
                    <img src={ASSET_PATHS.packageIcon} alt="Retry" />
                    <p className="text-sm flex items-center">{matchingOrder?.package_Name}</p>
                  </div>
                  <div className="flex gap-1">
                    <img src={ASSET_PATHS.locationWhiteIcon} alt="Retry" />
                    <p className="text-xs flex items-center">{matchingOrder?.address}</p>
                  </div>
                </div>

                <div className="absolute right-0 top-0 gap-1 items-center flex bg-orange-400 px-2 py-1 rounded-full text-xs font-bold">
                  <img src={ASSET_PATHS.tablerProgressWhite} alt="Progress" />
                  <div className="flex gap-[0.4]">
                    <span className="text-opacity-100 text-[0.7rem]">Items</span>
                    <span className="ml-1 text-opacity-100 text-[0.7rem]">{workOrderDetail[workOrder_ID]?.totalAssets || 0}</span>
                  </div>
                </div>
                {/* <div className="mt-auto text-white flex items-center font-semibold gap-1">
                  {isLoading ? (
                    <ImSpinner2 className="animate-spin mr-2 text-white" />
                  ) : (
                    <div
                      className={`flex items-center gap-1 px-4 py-2 rounded-full text-sm font-bold ${
                        (matchingOrder?.assetCount !== matchingOrder?.completedAssetCount || 
                        (matchingOrder?.assetCount ?? 0) === 0 || 
                        matchingOrder?.workOrderStatus === WorkOrderStatus.Completed || 
                        items?.length > 0 || 
                        matchWorkOrderPending) 
                          ? 'opacity-50 cursor-not-allowed text-white' 
                          : 'text-green-500'
                      }`}
                    >
                      <img
                        src={
                          (matchingOrder?.assetCount !== matchingOrder?.completedAssetCount || 
                          (matchingOrder?.assetCount ?? 0) === 0 || 
                          matchingOrder?.workOrderStatus === WorkOrderStatus.Completed || 
                          items?.length > 0 || 
                          matchWorkOrderPending)
                            ? ASSET_PATHS.clipboardCheckWhite
                            : ASSET_PATHS.clipboardCheckGreen
                        }
                        alt="Clipboard Check"
                        className="fill-current"
                      />
                      <button
                        onClick={() => setIsSubmitWorkOrderModalOpen(true)}
                        disabled={
                          matchingOrder?.assetCount !== matchingOrder?.completedAssetCount ||
                          (matchingOrder?.assetCount ?? 0) === 0 ||
                          matchingOrder?.workOrderStatus === WorkOrderStatus.Completed ||
                          items?.length > 0 ||
                          matchWorkOrderPending
                        }
                        className={`text-[0.875rem] font-bold ${
                          (matchingOrder?.assetCount !== matchingOrder?.completedAssetCount || 
                          (matchingOrder?.assetCount ?? 0) === 0 || 
                          matchingOrder?.workOrderStatus === WorkOrderStatus.Completed || 
                          items?.length > 0 || 
                          matchWorkOrderPending) 
                            ? 'text-white' 
                            : 'text-green-500'
                        }`}
                      >
                        Submit
                      </button>
                    </div>
                  )}
                </div> */}
              </div>
            </div>
            <div className="border border-gray-300 px-2 pb-4 rounded-b-2xl">
              <div className="flex-grow p-4 px-2 space-y-4 h-[calc(100vh-300px)] overflow-y-auto hide-scrollbar">
                {matchingOrder && workOrderDetail[workOrder_ID]?.items?.length > 0 ? (
                  workOrderDetail[workOrder_ID]?.items?.map((wordOrderItems: any) => (
                    <AssetCard
                    key={wordOrderItems?.item_ID}
                    asset={wordOrderItems}
                    workOrder_ID={workOrder_ID}
                    workOrder={matchingOrder}
                    onOpenSkipModal={handleOpenSkipModal}
                    onOpenUnSkipModal={handleOpenUnSkipModal}
                  />
              ))
                ) : (
                  workOrderDetail[workOrder_ID]?.items ? (
                    <p className="text-center text-gray-500">No items found</p>
                  ) : (
                    <div className="flex justify-center items-center">
                      <div className="w-8 h-8 border-4 border-t-transparent border-primary rounded-full animate-spin"></div>
                    </div>
                  )
                )}
              </div>
              {workOrderDetail[workOrder_ID]?.workOrderStatus && workOrderDetail[workOrder_ID]?.workOrderStatus != WorkOrderStatus.Completed && (
                <button
                  className="fixed bottom-6 left-1/2 transform -translate-x-1/2 bg-primary text-white rounded-full p-4 shadow-xl flex justify-center items-center"
                  onClick={navigateToAddAsset}
                >
                  <FaPlus size={24} />
                </button>
              )}

            </div>
          </div>

          {!showToast && (
            <div
              {...handlers}
              className="flex fixed gap-2 bottom-4 left-1/2 transform -translate-x-1/2 w-[92%] bg-primary text-white p-3 rounded-lg"
              style={{ transition: "none" }}
            >
              <img src={ASSET_PATHS.exclamationCircle} alt="Retry" />
              Media saved offline. Retry when you're connected.
            </div>
          )}
        </div>
      </PullToRefresh>
      
      {isSkipModalOpen && (
        <BlockConfirmationModal
          isOpen={isSkipModalOpen}
          onClose={handleCloseSkipModal}
          onConfirm={handleSkipUnSkipBlockItem}
        />
      )}

      {isUnSkipModalOpen && (
        <UnSkipModal
          isOpen={isUnSkipModalOpen}
          onClose={handleCloseUnSkipModal}
          onConfirm={handleSkipUnSkipBlockItem}
        />
      )}

      {/* {isSubmitWorkOrderModalOpen && (
        <SubmitWorkOrderModal
          isOpen={isSubmitWorkOrderModalOpen}
          onClose={handleCloseSubmitWorkOrderModal}
          onConfirm={handleSubmitWorkOrder}
        />
      )} */}
    </>
  );
};

export default Assets;
